<template>
  <div class="el-main">
    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>학력 입력</h2>
          <p>"자동 입력"을 사용하면 입학·졸업연도를 자동으로 계산할 수 있습니다.</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">「이상」을 표시하지 않음 </el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear" :month="basicData.birthMonth"
                :day="basicData.birthDay"></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button v-if="formatData.educationalHistories && formatData.educationalHistories.length > 1"
                  @click="$modal.show('educational-reset')">리셋</el-button>
              </div>
              <modal name="educational-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('educational-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">이력리셋</div>
                <span>입력된 학력을 모두 삭제합니다.확인 해주세요.</span>

                <div class="text-left">
                  <el-button type="primary"
                    @click="$modal.hide('educational-reset'); resetEducationalBackgrounds()">리셋함</el-button>
                  <el-button @click="$modal.hide('educational-reset')">리셋안함</el-button>
                </div>
              </modal>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">졸업 예정 <span style="color:red;">※졸업년도는 필수로 입력 해주세요.</span></div>
            <div class="item-body">
              <el-select v-model="formatData.gradeYear" placeholder="선택 해주세요">
                <el-option v-for="item in gradeYearOptions" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>

          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory" v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories" @click.native="activateHistoryItem(item.uuid)"
                :item="item" :length="formatData.educationalHistories.length" :index="index" :key="item.uuid"
                :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }" :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index" :createDate="formatData.createDate"
                :descriptionPlaceholder="'학력 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addEducationalHistory()"></el-button>
            </div>
          </div>
          <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>경력 입력</h2>
          <p>"자동 입력"을 사용하면 입학·졸업연도를 자동으로 계산할 수 있습니다.</p>
          <el-checkbox v-model="formatData.notDisplayIjyo">「이상」을 표시하지 않음 </el-checkbox>
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
              <auto-job-histories v-on:job-histories-created="setJobHistories" :birth-year="basicData.birthYear"
                :birth-month="basicData.birthMonth" :birth-day="basicData.birthDay"></auto-job-histories>
              <div class="button-reset">
                <el-button type="" v-if="formatData.jobHistories && formatData.jobHistories.length > 1"
                  @click="$modal.show('job-reset')">리셋</el-button>
              </div>
              <modal name="job-reset" :adaptive="true" :scrollable="true" height="auto">
                <div class="v--modal-close-top">
                  <el-button @click="$modal.hide('job-reset');" icon="el-icon-close" type="text"></el-button>
                </div>
                <div class="title">경력 리셋</div>
                <span>입력된 학력을 모두 삭제합니다.확인 해주세요.</span>
                <div>
                  <el-button type="primary" @click="$modal.hide('job-reset'); resetJobHistories()">리셋함</el-button>
                  <el-button @click="$modal.hide('job-reset')">리셋안함</el-button>
                </div>
              </modal>
            </div>
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addJobHistory" v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory" v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.jobHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'경력 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addJobHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
              <i class="el-icon-warning"></i>&ensp;{{ previewErrors.eduJobHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>면허・자격 입력</h2>
          <p>주요 면허·자격은 예문에서 고를 수 있습니다.</p>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog');" type="success">예문에서추가</el-button>
            <modal name="license-dialog" :adaptive="true" :scrollable="true" height="auto">
              <div class="v--modal-close-top">
                <el-button @click="$modal.hide('license-dialog');" icon="el-icon-close" type="text"></el-button>
              </div>
              <div class="title">예문선택</div>
              <div class="description">
                <p>선택한 예문이 추가되었습니다.</p>
              </div>
              <ul class="example-sentence">
                <li v-for="(item, index) in exampleSentences.license"
                  v-on:click="addLicenseHistory(null, { description: item }); $modal.hide('license-dialog');"
                  :key="index">
                  <div class="title">{{ index }}</div>
                  <div class="body" v-html="item"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog');">닫기</el-button>
              </div>
            </modal>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item v-on:add-history-item="addLicenseHistory" v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory" v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)" :item="item" :length="formatData.licenseHistories.length"
                :index="index" :key="item.uuid" :id="item.uuid" :class="{ 'active': activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index" :minYear="basicData.birthYear" :createDate="formatData.createDate"
                :descriptionPlaceholder="'면허・자격 입력'" :descriptionMaxLength="descriptionMaxLength"></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button icon="el-icon-plus" circle type="success" @click="addLicenseHistory()"></el-button>
            </div>
            <div class="attention-limit column" v-if="previewErrors.licenseHistory">
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'reason'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>지원동기 입력</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">예문에서추가</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한 예문이 추가되었습니다.</p>
              <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reason = item.replace(/<br>/ig, '\n'); $modal.hide('reason-dialog')"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">닫기</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reason"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reason">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'reasonNew'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>자기PR 입력</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success">예문에서추가</el-button>
        </div>

        <div class="card-content">
          <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한 예문이 추가되었습니다.</p>
              <p class="attention">예문을 선택하면 현재 입력 중인 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.reason"
                v-on:click="formatData.reasonNew += item.replace(/<br>/ig, '\n') + '\n'; $modal.hide('reason-dialog')"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')">닫기</el-button>
            </div>
          </modal>
          <el-input type="textarea" v-model="formatData.reasonNew"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.reasonNew">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'others'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>통근 시간 외</h2>
          <p>출퇴근 시간이나 부양가족 등을 입력합니다.</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div class="edit-form-item" v-if="optionItems.commuteDescription & this.formatId != 'rirekisho_job_new'">
              <div class="item-name">통근 수단<small>（전철, 버스, 자가용 등）</small></div>
              <div class="item-body">
                <el-input class="input-md" type="textarea" placeholder="전철" v-model="formatData.commuteDescription"
                  :autosize="{ minRows: 1, maxRows: 2 }">
                </el-input>
                <!--{{ $formLib.charCount(formatData.commuteDescription) }}-->
                <div class="error attention-limit character"
                  v-if="$formLib.charCount(formatData.commuteDescription) > 84">
                  <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.
                </div>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">통근시간</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title="시간" type="number"
                  v-model="formatData.commuteHours"></el-input> 시간
                <el-input class="input-xs" type="number" placeholder="" title="분"
                  v-model="formatData.commuteMinutes"></el-input> 분
              </div>

              <div class="item-name">부양가족(배우자 제외)</div>
              <div class="item-body">
                <el-input class="input-xs" placeholder="" title=부양가족수 type="number"
                  v-model="formatData.spouseNumber"></el-input> 명
              </div>
              <div class="item-name">배우자</div>
              <div class="item-body">
                <el-radio v-model="formatData.hasSpouse" :label="true"> 있음</el-radio>
                <el-radio v-model="formatData.hasSpouse" :label="false"> 없음</el-radio>
              </div>
              <div class="item-name">배우자의 부양의무</div>
              <div class="item-body">
                <el-radio v-model="formatData.underDutyToSupport" :label="true">있음</el-radio>
                <el-radio v-model="formatData.underDutyToSupport" :label="false">없음</el-radio>
              </div>
              <br>
              <div class="item-name" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                유학생입니까?</div>
              <div class="item-body" v-if="formatId == 'rirekisho_job_new' || formatId == 'rirekisho_job_new_single'">
                <el-radio v-model="formatData.foreignStudent" :label="true">네</el-radio>
                <el-radio v-model="formatData.foreignStudent" :label="false">아니오</el-radio>
              </div>
              <el-checkbox v-model="formatData.notDisplayRecommend">소개·추천을 표시하지 않음</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'requests'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>본인 희망란 입력</h2>
          <p>급여, 직종, 근무시간, 근무지 등의 원하시는 내용을 입력할 수 있습니다(임의)</p>
        </div>
        <div class="add-item">
          <el-button @click="$modal.show('request-dialog')" type="success">예문에서추가</el-button>
        </div>
        <div class="card-content">
          <div class="edit-form-item" v-if="false">
            <div class="item-name">현재연봉</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="현재연봉" type="number"
                v-model="formatData.nowNensyu"></el-input> 만원
            </div>
            <div class="item-name">희망연봉</div>
            <div class="item-body">
              <el-input class="input-xs" placeholder="" title="희망연봉" type="number"
                v-model="formatData.kibouNensyu"></el-input> 만원
            </div>
            <div class="item-name">※위 항목을 입력한 후 예문에서 추가 버튼을 클릭하여 예문을 선택하면 자동으로 반영됩니다.</div>
          </div>
          <br>
          <modal name="request-dialog" :adaptive="true" :scrollable="true" height="auto">
            <div class="v--modal-close-top">
              <el-button @click="$modal.hide('request-dialog');" icon="el-icon-close" type="text"></el-button>
            </div>
            <div class="title">예문선택</div>
            <div class="description">
              <p>선택한 예문이 추가되었습니다.</p>
              <p class="attention">예문을 선택하면 현재 입력한 문장은 덮어쓰게 되므로 주의하시기 바랍니다.</p>
            </div>
            <ul class="example-sentence">
              <li v-for="(item, index) in exampleSentences.request"
                v-on:click="formatData.request += item.replace(/<br>/ig, '\n').replace('OOO', formatData.nowNensyu).replace('XXX', formatData.kibouNensyu) + '\n'; $modal.hide('request-dialog');"
                :key="index">
                <div class="title">{{ index }}</div>
                <div class="body" v-html="item"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('request-dialog');">닫기</el-button>기
            </div>
          </modal>
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 15 }"
            placeholder="급여, 직종, 근무시간, 근무지 등 희망사항이 있으면 입력" v-model="formatData.request">
          </el-input>
          <div class="attention-limit character" v-if="previewErrors.request">
            <i class="el-icon-warning"></i> 입력 가능한 문자 수를 초과했습니다.문장을 짧게 해주세요.
          </div>
        </div>
        <div class="card-header" v-if="getMode != 'production1'" style="text-align:center;">
          <h2>야기오퍼등록</h2>
          <p><a href="/kr/resume/yagiofferhelp" target="_blank"><img
                src="/kr/resume/static/renew_img/bnr/yagioffer_lp_link_pc.png" class="pc"
                style="text-align:center;width:70%" /><img
                src="/kr/resume/static/renew_img/bnr/yagioffer_lp_link_sp.png" class="sp"
                style="text-align:center;width:100%" /></a></p>
          <p>아래의 4가지선택만으로 등록완료</p>
          <p>당신에게 관심이 있는 회사로부터 직접 제안을 받을 수 있습니다.</p>
          <el-checkbox v-model="formatData.registYagioffer">약관에 동의하여 등록하기</el-checkbox>
          <p style="font-size:70%"><a href="/kr/resume/yagiofferterms" target="_blank">야기 오퍼 이용약관, 개인정보 보호 방침</a></p>
        </div>
        <div class="card-content" v-if="getMode != 'production1'" style="text-align:center;">
          <div class="edit-form-item">
            <div class="item-name">학부·학과</div>
            <div class="item-body">
              <el-select v-model="formatData.department" placeholder="선택 해주세요">
                <el-option v-for="item in departmentOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">희망근무지</div>
            <div class="item-body">
              <el-select v-model="formatData.hopeAreaPref" placeholder="선택 해주세요">
                <el-option v-for="item in prefOptions" :key="item" :label="item" :style="item"
                  :value="item"></el-option>
              </el-select>
            </div>
            <div class="item-name">희망업계</div>
            <div class="item-body">
              <el-select v-model="formatData.hopeIndustry" placeholder="선택 해주세요">
                <el-option v-for="item in hopeIndustryOptions" :key="item" :label="item" :style="item"
                  :value="item"></el-option>
              </el-select>
            </div>
            <div class="item-name">희망직종</div>
            <div class="item-body">
              <el-select v-model="formatData.hopeJobcategory" placeholder="선택 해주세요">
                <el-option v-for="item in hopeJobcategoryOptions" :key="item" :label="item" :style="item"
                  :value="item"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>이력서 작성일 입력</h2>
          <p>실제로 서류를 지참하는 날 또는 우편으로 보낼 날짜를 선택 해주세요.</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">오늘로 선택</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">내일로 선택</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="선택 해주세요"
                  :format="'yyyy년M월d일'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
          <br>
          <div v-if="$site.appFlag != 'b'">
            <el-collapse accordion v-model="activeName">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">추천</span>인쇄부터 우편까지 당신을 대신하여 !야기택배 서비스
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <p>취직 또는 이직을 희망하는 기업에게, 당신 대신 야기슈가 "이력서" ,"송부장","봉투"를 인쇄하여 발송해 드립니다.(경력기술서는 자유선택)</p><br>
                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button style="width:100%;border:0px;padding:0px;background: #EFF8F8;"
                        :disabled="!$deviceLib.isOnline || !isSendYagiPostEnabled"
                        @click="$eventHub.$emit('send-special-post', formatId);">
                        <h3>야기택배<span>이용하기</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>


    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" style="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>작성한 이력서확인</h2>
        </div>
      </div>
    </div>


    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">

      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses"></download-item>
    </div>


  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #EFF8F8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
  font-family: "M PLUS Rounded 1c";
}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}


.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'NewRirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: ''
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      isSendedYagishIntern: false,
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      isNew: false,
      textareaMinRows: 3,
      reasonLabel: '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23년졸'
        },
        {
          value: '24',
          label: '24년졸'
        },
        {
          value: '25',
          label: '25년졸'
        },
        {
          value: '26',
          label: '26년졸'
        },
        {
          value: '27',
          label: '27년졸'
        },
        {
          value: '99',
          label: '기타'
        }
      ],
      departmentOptions: ['법학・정책계', '경제・경영계', '상학계', '사회・복지계', '국제관계계', '외국어계', '문학계', '교원양성계', '교육계', '가정계', '종교・신학계', '체육·예술·음악계', '상선계', '이과계', '의료·보건계', '수리물리계', '기계계', '전기·전자·제어계', '정보계', '응용물계', '토목계', '건축계', '생물계', '화학·물질계', '금속계', '기타 이공계', '농업·농학계', '수산계', '축산·랍농계', '약학계', '의학·치과계', '수의학계', '위생·의료·간호계'],
      graduationYearOptions: ['23년졸', '24년졸', '25년졸'],
      hopeIndustryOptions: ['IT・통신', '소프트웨어・정보처리', '인터넷관련・게임・앱관련', '기계・산업용장비・전기・OA기기', '자동차・자동차부품・운송용기기', '컴퓨터・통신기기・정밀기기', '전자부품・반도체', '식품・음료・담배・사료', '화학・의약・화장품', '철강・비철금속・금속제품', '석유・석탄・고무・플라스틱', '유리・세라믹・시멘트', '펄프・종이・지공・인쇄・인쇄관련', '일용품・문구・오피스용품', '건축자재・익스테리어', '인테리어・주택관련', '패션・의류관련', '스포츠・장난감・게임기기', '기타 제조업・생산관련', '전기・가스・석유・수도', '방송(텔레비전・라디오 포함)', '신문・출판', '광고', '기타(연예・엔터테인먼트 관련 등)', '운송(철도・항공・해운・물류 등)', '종합상사', '전문상사', '백화점・슈퍼마켓・드럭스토어・편의점・홈센터', '통신판매, 전문점・기타 소매', '은행(협동조직금융 포함)', '증권', '보험', '기타금융(크레딧 등)', '리스・렌탈', '개발자', '건설・건축설계・하우스메이커', '설비관련', '플랜트・플랜트엔지니어링', '부동산거래・부동산임대・부동산관리', '디자인・예술관련', '컨설팅・마케팅・조사', '기타전문・기술서비스', '호텔・여관', '외식', '기타푸드', '이미용・에스테・피트니스클럽', '여행・관광', '가사서비스・클리닝', '결혼·장례', '기타생활관련서비스', '오락・레저서비스', '교육관련', '의료・보육・요양, 복지', '환경・리사이클・폐기물처리', '정비・수리', '인력서비스', '기타사업서비스(경비, 콜센터 등)', '기타'],
      hopeJobcategoryOptions: ['영업', '사무·비서·접수', '회계', '총무·인사', '바이어', '법무', '지적재산부서', '기획', '마케팅', '선전·홍보', '경영기획', '경영컨설턴트', '환율딜러·트레이더', '증권애널리스트', '융자·자산운용(펀드매니저 등)', '금융자문가', '액추어리', '시스템엔지니어·프로그래머', '웹엔지니어', '네트워크엔지니어', '보안엔지니어', '인프라·데이터엔지니어', 'AI엔지니어', '임베디드엔지니어', '커스토머엔지니어', '사내SE·정보시스템', '연구직(제조계)', '설계개발', '생산·제조', '물류·재고관리', '세일즈엔지니어', '품질관리', '의료기술', 'MR(의약정보담당자)', '연구개발(의약계)', '약사', '영양사', '복지사·요양사·홈헬퍼', '강사·인스트럭터', '전문컨설턴트', '건축·토목설계', '시공관리', '웹프로듀서·디렉터', '웹디자이너', '디자이너', '게임크리에이터', '게임프로그래머', '데이터사이언티스트·애널리스트', '기자·라이터', '편집·제작', '판매·접객', '점장(점포경영·운영)', '스퍼바이저', '농업', '임업', '수산업'],
      prefOptions: ['서울', '부산', '인천', '대구', '대전', '광주', '울산', '세종', '경기', '충북', '전라', '경상', '강원', '제주', '해외'],
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (let key in historyList) {
        let item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      let tArea = this.$refs.yourTextarea
      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew = tmpStr.substring(0, startPos) + selectedSentences + tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (let key in historyList) {
        let item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addEducationalHistory: function (index, columns) {
      this.addHistory(this.formatData.educationalHistories, index, 'EducationalHistory_', columns)
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      this.addHistory(this.formatData.licenseHistories, index, 'LicenseHistory_', columns)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    setIsSendedYagishIntern: function (rslt) {
      this.isSendedYagishIntern = rslt
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy년 m월 d일')
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (!this.formatData.registYagioffer) {
      this.formatData.registYagioffer = true
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel = '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel = '지원동기, 특기, 좋아하는학과, 어필포인트 등, 쓰기가 막막할때에는 예문을 바탕으로 작성할 수 있습니다.'
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('set_is_sendedYagishIntern', this.setIsSendedYagishIntern)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('set_isSendedYagishIntern', this.setIsSendedYagishIntern)
  }
}
</script>
